import deepmerge from 'deepmerge';
import { ENVIRONMENT_GLOBAL } from '../global_env';

export const environment = deepmerge(ENVIRONMENT_GLOBAL, {
  envName: 'test',
  production: true,
  matomoSrc: '',
  redirect: {
    host: 'https://test-oms-admin.meinhplus.de'
  },
  files: {
    paths: {
      host: 'https://test.meinhplus.de'
    }
  },
  links: {
    applications: {
      mh2: 'https://test.meinhplus.de',
      hcp: 'https://test-dashboard.meinhplus.de',
      l2: 'https://test-administration.meinhplus.de'
    }
  },
  auth_L1: {
    client_id: 'oms-tool-support',
    scope: 'phone email profile openid',
    endpoint: {
      host: 'https://test-account.meinhplus.de',
      paths: {
        prefix: '/auth/realms/hekatron-tuer-tor'
      }
    }
  },
  backend: {
    scope: 'oms',
    client_id: 'oms-adminapp-bT8qL2fDn9Wp3JrY',
    endpoint: {
      host: 'https://api.test-oms.meinhplus.de'
    }
  }
});
